export enum EBetslipToggleActions {
  /*Toggle States start*/
  SET_OPEN = 'SET_OPEN',
  SET_IS_OPENED = 'SET_IS_OPENED',
  SET_MUST_OPEN = 'SET_MUST_OPEN',
  SET_MUST_CLOSE = 'SET_MUST_CLOSE'
  /*Toggle States end*/
}
